module.exports = BD.Model.extend({
    organization: BD.belongsTo('Billy.Organization'),
    name: BD.attr('string'),
    isTransactionSummaryEnabled: BD.attr('boolean'),
    isArchived: BD.attr('boolean'),
    defaultContraAccount: BD.belongsTo('Billy.Account'),
    balanceAccounts: BD.hasMany('Billy.DaybookBalanceAccount', 'daybook', { isEmbedded: true })
})
